import { render, staticRenderFns } from "./dehumidifierSmall.vue?vue&type=template&id=44966144&scoped=true"
import script from "./dehumidifierSmall.vue?vue&type=script&lang=js"
export * from "./dehumidifierSmall.vue?vue&type=script&lang=js"
import style0 from "./dehumidifierSmall.vue?vue&type=style&index=0&id=44966144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44966144",
  null
  
)

export default component.exports